import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { apiHelper } from "../../lib/ApiHelper";
import "../MainBox.css";
import "../../Landing_Page/Landing.css";

export default function NotesPopUpDK(props) {
    const [isProcessing, setIsProcessing] = useState(true);
    const [originalNote, setOriginalNote] = useState('');
    const [textSize, setTextSize] = useState(2000);
    const [Readonly, setReadonly] = useState(null);
    const [Visibility, setVisibility] = useState(null);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState('');
    const [isAuthor, setIsAuthor] = useState(false);
    const [pubDK, setpubDK] = useState(false);
    const [notesData, setNotesData] = useState({
        noteID: 0,
        isbn: props.ISBNId,
        status: "Active", isPriority: false, visibility: "Public", note: "", creator: props.upn, Action: ''
    })

    useEffect(() => {
        console.info("this is called");
        loadNotes();
    }, [props?.noteID]);

    const loadNotes = async () => {
        try {
            setIsProcessing(true); setError(null); setMessage('');
            if (!props.noteID || props.noteID <= 0) {
                setNotesData({
                    noteID: 0,
                    isbn: props.ISBNId,
                    status: "Active", isPriority: false, visibility: "Public", note: "", creator: props.upn, Action: ''
                });
              //  setisAuthor(true);
                setIsAuthor(true);
                return;
            }
            const data = await apiHelper.inventoryPostCall("getNotes", { value: props.noteID });
            if (data != undefined && data != null) {
                setNotesData(data);
                setOriginalNote(`${props.userInitials} : `);
                setpubDK(data.visibility == "Public" && props?.isEditable && !(props.upn.toLowerCase().trim() === data.creator.toLowerCase().trim()));
      
                setIsAuthor(props.upn.toLowerCase().trim() === data.creator.toLowerCase().trim());
               
                setVisibility(data.visibility ?? '');
                setTextSize(2000 - data?.note?.length);
            }
        } catch ({ name, message }) {
            console.error('Failed loadNotes', name, message);
            setError(`Failed to load note with error ${message}`)
        } finally {
            setIsProcessing(false);
            /*  setReadonly((!(!isAuthor || isProcessing || !notesData.note || notesData.note?.trim().length == 0) || !(!isAuthor || isProcessing || !props.noteID || props.noteID <= 0) || !(isAuthor || isProcessing || !props.noteID || props.noteID <= 0 || !(notesData.visibility === 'Public' && !props.isEditable))));*/
            setReadonly(!isAuthor || isProcessing);
        }
    }

    const showFormatDate = (dateString) => {
        if (dateString) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const formattedDate = `${month}/${day}/${year}`;
            return formattedDate;
        }
        return null;
    }

    const handlFieldChange = (name, value) => {
        setNotesData(prevState => ({
            ...prevState,
            [name]: value
        }));
    }
    const handlAddOnFieldChange = (name, value) => {
        setOriginalNote(value);
    }

    

    const saveNotes = async (event) => {
        const { value } = event.target;
        try {
            setIsProcessing(true); setError(null); setMessage(null);
            let entity = notesData;
            if (pubDK) {
                entity.note = `${notesData.note}\n${originalNote}`;
            }
            entity.Action = value;
            entity.creator = value == "U" ? notesData.creator : props.upn;
            entity.isbn = props.ISBNId;
            entity.ModifyUPN = value == "U" ? props.upn : notesData.updatedBy ?? props.upn;
        
            const data = await apiHelper.inventoryPostCall("createNotes", entity, true);
            props.onSave(true);
            if (value == 'D') {
                setMessage("Note deleted successfully.");
            } else {
                setMessage("Note saved successfully.");
            }
            props.onClose();
        } catch ({ name, message }) {
            console.error('Failed SaveNotes', name, message);
            const operation = value == 'D' ? 'delete' : value == 'I' ? 'save new' : 'update';
            setError(`Failed to ${operation} note with error ${message}`)
        } finally {
            setIsProcessing(false);
        }
    }


    return (
        <>
            <div className="popup-overlay container-fluid notesPopUp">
                <div className="popup" style={{ overflowY: "auto", backgroundColor: "#F5F5F6" }}>
                    <p style={{ paddingLeft: "15px" }} className="mb-0  fw-bold fs-7 pb-1">Update or View Note<button className="popup-close-btn" onClick={props?.onClose}></button></p>
                    <hr style={{ height: "2px", borderWidth: "0", color: "gray", backgroundColor: "grey", margin: "0" }} />
                    <div className={`${pubDK ? 'note-popup-pubDkHeight' : ''} note-popup-content pt-2` } >
                        <Row>
                            <Col className="flex-grow-0 mt-1" md={2}>
                                <table className="input-table">
                                    <tr>
                                        <th>Create Date</th>
                                    </tr>
                                    <tr>
                                        <td className="pl-1">
                                            {showFormatDate(notesData.createDate) || showFormatDate(Date())}
                                        </td>
                                    </tr>
                                </table>
                            </Col>
                            <Col className="flex-grow-0 mt-1" md={2}>
                                <table className="input-table">
                                    <tr>
                                        <th>Author</th>
                                    </tr>
                                    <tr>
                                        <td>
                                            {notesData.userName || ' '}
                                        </td>
                                    </tr>
                                </table>
                            </Col>{notesData.updatedBy &&
                                <Col className="flex-grow-1 mt-1" md={2}>
                                    <table className="input-table">
                                        <tr>
                                            <th>Updated By</th>
                                        </tr>
                                        <tr>
                                            <td>
                                                {notesData.updatedBy || ' '}
                                            </td>
                                        </tr>
                                    </table>
                                </Col>}
                        </Row>
                        <Row>
                            <Col>
                                <label>
                                    <input id='visibility' type="radio" name="visibility" id="visibility"
                                        value="Public"
                                        checked={notesData.visibility.toLowerCase() == "public"}
                                        disabled={!isAuthor || isProcessing || !props.isEditable}
                                        onChange={(e) => handlFieldChange('visibility', e.target.value)} />Public</label><br />
                                <label>
                                    <input id='visibility' type="radio" name="visibility" id="visibility"
                                        value="Private"
                                        disabled={!isAuthor || isProcessing || !props.isEditable}
                                        checked={notesData.visibility.toLowerCase() == "private"}
                                        onChange={(e) => handlFieldChange('visibility', e.target.value)} />Private</label>
                            </Col>
                            <Col>
                                <label>
                                    <input id='status' type="radio" name="status" id="status"
                                        value="Active"
                                        disabled={!isAuthor || isProcessing || !props.isEditable}
                                        checked={notesData.status.toLowerCase() == "active"}
                                        onChange={(e) => handlFieldChange('status', e.target.value)} />Active</label><br />
                                <label>
                                    <input id='status' type="radio" name="status" id="status"
                                        value="Inactive"
                                        checked={notesData.status.toLowerCase() == "inactive"}
                                        disabled={!isAuthor || isProcessing || !props.isEditable}
                                        onChange={(e) => { handlFieldChange('status', e.target.value); handlFieldChange('isPriority', false); }} />InActive</label>
                            </Col>
                            <Col>
                                <label>
                                    <input type="radio" name="isPriority" id="isPriority"
                                        value="Priority"
                                        disabled={!isAuthor || isProcessing || !props.isEditable}
                                        checked={notesData.isPriority}
                                        onChange={(e) => handlFieldChange('isPriority', true)} />Priority</label><br />
                                <label>
                                    <input type="radio" name="isPriority" id="isPriority"
                                        value="Non-Priority"
                                        disabled={!isAuthor || isProcessing || !props.isEditable}
                                        checked={!notesData.isPriority}
                                        onChange={(e) => handlFieldChange('isPriority', false)} />Non-Priority
                                </label>
                            </Col>
                        </Row>
                        <Row>
                            <table className="note-area">
                                <tr>
                                    <th>Note</th>
                                </tr>
                                <tr>
                                    <td className={`${pubDK ? 'shortHeight' : 'normalHeight'}`}>
                                        <textarea id="inputText"
                                            className={`${pubDK ? 'pubDk' : ''}`}
                                            style={{ border: "1px solid black", padding: "6px", backgroundColor: `${(pubDK || notesData?.note.length >= 2000) ? 'lightgrey' : ''}`, overflow: "auto"}}
                                            value={notesData?.note ?? ""}
                                            readOnly={pubDK}
                                            maxlength={2000}
                                            disabled={!props.isEditable}
                                            onChange={(e) => handlFieldChange("note", document.getElementById('inputText').value)}></textarea>
                                        
                                          
                                    
                                    </td></tr>
                                    
                                {pubDK ? <>
                                    <tr>
                                        <th>Add to Note</th>
                                    </tr>
                                    <tr>
                                        <td className={`${pubDK ? 'shortHeight' : 'normalHeight'}`}> 

                                            {/*     readOnly={!(!isAuthor || isProcessing || !notesData.note || notesData.note?.trim().length == 0) || !(!isAuthor || isProcessing || !props.noteID || props.noteID <= 0) || !(isAuthor || isProcessing || !props.noteID || props.noteID <= 0 || !(notesData.visibility == 'Public' && !props.isEditable)) }*/}
                                            <textarea id="inputText-addon"
                                                value={textSize <= 0 ? "Maximum capacity reached !": originalNote}
                                                maxlength={textSize}
                                                placeholder={textSize <= 0 ? "Maximum capacity reached !" : ""}
                                                readOnly={textSize <= 0}
                                                disabled={!props.isEditable}
                                                style={{ padding: "6px", overflow: "auto", backgroundColor: `${textSize <= 0 ? 'lightgrey' : ''}` }}
                                                onChange={(e) => handlAddOnFieldChange("note", document.getElementById('inputText-addon').value)}></textarea>
                                        </td>
                                    </tr>
                                </>:<></>}
                                
                            </table>
                        </Row>
                        <Row className="action-bar alerts" style={{ marginLeft: "auto", marginRight: "auto", display: "grid" }}>
                            <div>
                                {error && <span className="error">{error}</span>}
                                {message && <span className="success">{message}</span>}
                            </div>
                        </Row>
                        <Row className="action-bar mb-2" style={{ marginLeft: "auto", marginRight: "auto", display: "grid" }}>
                            <div>
                                <button className="ISBNSubmit note-button-width ml-1"
                                    value={!props.noteID || props.noteID <= 0 ? 'I' : 'U'}
                                    disabled={(!(isAuthor || (pubDK && textSize > 0)) || isProcessing || !notesData.note || notesData.note?.trim().length == 0) || !props.isEditable
                                        /*!isAuthor || isProcessing || !notesData.note || notesData.note?.trim().length == 0*/}
                                    onClick={ saveNotes}>{!props.noteID || props.noteID <= 0 ? 'Save' : 'Update'}</button>
                                <button className="ISBNSubmit note-button-width ml-5" value='D'
                                    disabled={(!isAuthor || isProcessing || !notesData.note || !props.isEditable)
                                        /*!isAuthor || isProcessing || !props.noteID || props.noteID <= 0*/}
                                    onClick={saveNotes}>Delete</button>
                                {/*<button className="ISBNSubmit note-button-width ml-5" value='I'
                                    disabled={isAuthor || isProcessing || !props.noteID || props.noteID <= 0 || !(Visibility === 'Public' && !props.isEditable)}
                                    onClick={saveNotes}>Add Note </button>*/}
                            </div>
                        </Row>
                        
                    </div>
                </div>
            </div>
       
        </>
    )
}